import React from 'react'
import styled, { css } from 'styled-components'
import { Components, Types } from '../../types';
import Icon from '../Icon'

// Props extended interface
interface IToggler extends Types.AppOptions {
  // Id of the toggler icon
  iconId: Types.Icons
  type?: 'outlined' | 'filled'
  color?: string
  // To set proper color
  fromCategory?: boolean
}

/**
 * A toggler rendering an Icon
 * @param props IToggler
 * @returns React FC
 */
const Toggler: React.FC<IToggler> = ({theme, iconId: id, ...props}) => {
  console.log(props)
;  return (
    <StyledToggler {...{...props, id}}>
      {/* Toggler Icon */}
      <Icon {...{
        ...props,
        id,
        size: theme.mobileMenu.iconSize,
      }} />
    </StyledToggler>
  )
}

const StyledToggler = styled.div<any>(({id}) => css`
  display: flex;
  cursor: pointer;
`);

export default Toggler
